<template>
    <section class="hero is-hero-bar">
        <div class="hero-body bodyHero">
            <div class="level herolevel">
                <div class="level-left">
                    <div class="level-item">
                        <a class="title">
                            <b-icon :icon="menuIcon" size="is-small" class="mx-4"></b-icon>
                            <slot />
                        </a>
                    </div>
                </div>
                <div v-show="hasRightVisible" class="level-right">
                    <div class="level-item">
                        <slot name="right" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'HeroBar',
        props: {
            hasRightVisible: {
                type: Boolean,
                default: true
            },
            menuIcon: {
                type: String,
                required: true
            }
        }
    };

</script>

<style>
    /* The band's layout, desktop and phone, is in scss/_eae-overrides.scss ("page title
       band"). The rules here stacked it in one column below 670px and shrank the title to
       1.5em below 384px, against the design's 22px. */
    .herolevel {
        display: flex;
    }

    .level-right {
        margin-top: 0 !important;
    }
</style>
